import { useInfiniteQuery } from '@tanstack/react-query';
import { useEffect, useMemo } from 'react';
import { getUsers } from './generated/idm-bff-api';
import type { GetUsersParams } from './generated/model';

export const getUsersPagedQueryKey = ['/idm/v4/users', 'infinite'];

export function useGetUsersPaged() {
  const q = useInfiniteQuery({
    queryKey: getUsersPagedQueryKey,
    initialPageParam: '',
    queryFn: async ({ pageParam }) => {
      const params: GetUsersParams = {
        pageSize: 1000,
      };
      if (pageParam) {
        params.cursor = pageParam;
      }

      const response = await getUsers(params);
      return response;
    },
    // it is important that this value is undefined for react query to know that
    // there are no more pages to fetch
    getNextPageParam: (lastPage) => {
      return lastPage.nextCursor || undefined;
    },
    staleTime: 60_000,
  });

  useEffect(() => {
    if (q.hasNextPage && !q.isFetchingNextPage) {
      q.fetchNextPage();
    }
  }, [q.hasNextPage, q.isFetchingNextPage, q.fetchNextPage]);

  const users = useMemo(
    () => q.data?.pages.flatMap((page) => page.result) ?? [],
    [q.data],
  );

  return {
    ...q,
    done: !(q.isPending || q.hasNextPage || q.isFetchingNextPage),
    users,
  };
}
